import { authService } from '@/services/auth.js';
import { HatElement } from '@/components/hat-element.js';

class HatRouter extends HatElement {
  private routes: any[];
  private _popstateHandler: (() => void) | null = null;

  constructor() {
    super();

    this.routes = [
      {
        path: "/admin/invitations/new",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-invitation-form'));
          return layout;
        }
      },
      {
        path: "/admin/invitations/{invitationId}",
        authRequired: true,
        roles: ['ADM'],
        render: (params: Record<string, string>) => {
          const layout = document.createElement('hat-layout-admin');
          const detail = document.createElement('hat-admin-invitation-detail');
          detail.setAttribute('invitation-id', params.invitationId);
          layout.appendChild(detail);
          return layout;
        }
      },
      {
        path: "/admin/invitations",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-invitations'));
          return layout;
        }
      },
      {
        path: "/admin/users/new",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-user-form'));
          return layout;
        }
      },
      {
        path: "/admin/users/{userId}/edit",
        authRequired: true,
        roles: ['ADM'],
        render: (params: Record<string, string>) => {
          const layout = document.createElement('hat-layout-admin');
          const form = document.createElement('hat-admin-user-form');
          form.setAttribute('user-id', params.userId);
          layout.appendChild(form);
          return layout;
        }
      },
      {
        path: "/admin/users",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-users'));
          return layout;
        }
      },
      {
        path: "/admin/qrcodes/new",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-asset-link-form'));
          return layout;
        }
      },
      {
        path: "/admin/services",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-services'));
          return layout;
        }
      },
      {
        path: "/admin/testing",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-testing'));
          return layout;
        }
      },
      {
        path: "/admin/maintenance-templates",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-maintenance-templates'));
          return layout;
        }
      },
      {
        path: "/admin/asset-type-properties",
        authRequired: true,
        roles: ['ADM'],
        render: () => {
          const layout = document.createElement('hat-layout-admin');
          layout.appendChild(document.createElement('hat-admin-asset-type-properties'));
          return layout;
        }
      },
      {
        path: "/admin",
        authRequired: true,
        roles: ['ADM'],
        redirect: "/admin/invitations"
      },
      {
        path: "/app/profile",
        authRequired: true,
        render: () => {
          const app = document.createElement("hat-layout-app");
          app.appendChild(document.createElement("hat-user-profile"));
          return app;
        }
      },
      {
        path: "/app/login",
        authRequired: false,
        render: () => {
          const app = document.createElement("hat-layout-app");
          app.appendChild(document.createElement("hat-login"));
          return app;
        }
      },
      {
        path: "/app/logout",
        authRequired: false,
        render: () => {
          const app = document.createElement("hat-layout-app");
          app.appendChild(document.createElement("hat-logout"));
          return app;
        }
      },
      {
        path: "/app/locations/new",
        authRequired: true,
        render: () => {
          const app = document.createElement("hat-layout-app");
          app.appendChild(document.createElement("hat-location-form"));
          return app;
        }
      },
      {
        path: "/app/locations/{locationId}",
        authRequired: true,
        render: (params: Record<string, string>, query: URLSearchParams) => {
          console.log('hot-router', 'params.locationId', params.locationId, 'query.get("is-new")', query.get("is-new"), 'query.get("is-new") === "true"', query.get("is-new") === "true");
          const app = document.createElement("hat-layout-app");
          const profile = document.createElement("hat-location-profile");
          profile.setAttribute("location-id", params.locationId);
          if (query.get("is-new") === "true") {
            profile.setAttribute("is-new", "true");
          }
          app.appendChild(profile);
          return app;
        }
      },
      {
        path: "/app/locations/{locationId}/edit",
        authRequired: true,
        render: (params: Record<string, string>) => {
          const app = document.createElement("hat-layout-app");
          const form = document.createElement("hat-location-form");
          form.setAttribute("location-id", params.locationId);
          app.appendChild(form);
          return app;
        }
      },
      {
        path: "/app/locations/{locationId}/assets/{assetId}",
        authRequired: true,
        render: (params: Record<string, string>) => {
          const app = document.createElement("hat-layout-app");
          if (params.assetId === 'new') {
            const form = document.createElement("hat-asset-form");
            form.setAttribute("location-id", params.locationId);
            app.appendChild(form);
          } else {
            const profile = document.createElement("hat-asset-profile");
            profile.setAttribute("location-id", params.locationId);
            profile.setAttribute("asset-id", params.assetId);
            app.appendChild(profile);
          }
          return app;
        }
      },
      {
        path: "/app/locations/{locationId}/assets/{assetId}/edit",
        authRequired: true,
        render: (params: Record<string, string>) => {
          const app = document.createElement("hat-layout-app");
          const form = document.createElement("hat-asset-form");
          form.setAttribute("location-id", params.locationId);
          form.setAttribute("asset-id", params.assetId);
          app.appendChild(form);
          return app;
        }
      },
      {
        path: "/app/assets/{assetId}",
        authRequired: false,
        render: (params: Record<string, string>) => {
          const home = document.createElement("hat-layout-home");
          const profile = document.createElement("hat-asset-public-profile");
          profile.setAttribute("asset-id", params.assetId);
          home.appendChild(profile);
          return home;
        }
      },
      {
        path: "/app/not-found",
        authRequired: false,
        render: () => {
          const home = document.createElement("hat-layout-home");
          home.appendChild(document.createElement("hat-not-found"));
          return home;
        }
      },
      {
        path: "/app/error",
        authRequired: false,
        render: () => {
          const home = document.createElement("hat-layout-home");
          home.appendChild(document.createElement("hat-error"));
          return home;
        }
      },
      {
        path: "/app",
        authRequired: true,
        render: () => {
          const app = document.createElement("hat-layout-app");
          app.appendChild(document.createElement("hat-app-landing"));
          return app;
        }
      },
      {
        path: "/",
        authRequired: false,
        render: () => {
          const home = document.createElement("hat-layout-home");
          home.appendChild(document.createElement("hat-welcome"));
          return home;
        }
      }
    ];
  }

  connectedCallback() {
    super.connectedCallback();
    this._popstateHandler = () => this.render();
    window.addEventListener("popstate", this._popstateHandler);
    this.render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._popstateHandler) window.removeEventListener("popstate", this._popstateHandler);
  }

  onNavigate(path: string) {
    history.pushState({}, "", path);
    this.render();
  }

  removeBasePath(path: string) {
    const basePath = "/client";
    if (path.startsWith(basePath)) {
      path = path.slice(basePath.length);
    }
    return path.replace(/\/+$/, '');
  }

  matchRoute(routePath: string, currentPath: string) {
    const paramNames: string[] = [];

    const regexPath = routePath.replace(/\{([^}]+)}/g, (_, key) => {
      paramNames.push(key);
      return "([^/]+)";
    });

    const regex = new RegExp(`^${regexPath}$`);
    const match = currentPath.match(regex);

    if (!match) return null;

    const params: Record<string, string> = {};
    paramNames.forEach((name, index) => {
      params[name] = match[index + 1];
    });

    return params;
  }

  async render(): Promise<void> {
    const rawPath = window.location.pathname;
    const basePath = this.removeBasePath(rawPath);
    const query = new URLSearchParams(window.location.search);

    for (const route of this.routes) {
      const params = this.matchRoute(route.path, basePath);
      if (!params) continue;

      if (route.authRequired) {
        const ok = await authService.ensureValidToken();
        if (!ok) {
          history.replaceState({}, "", "/app/login");
          return this.render();
        }
      } else {
        if (!authService.isAuthenticated()) {
          authService.refreshToken();
        }
      }

      if (route.roles?.length) {
        const authorized = route.roles.every((r: string) => authService.hasRole(r));
        if (!authorized) {
          history.replaceState({}, "", "/app");
          return this.render();
        }
      }

      if (route.redirect) {
        history.replaceState({}, "", route.redirect);
        return this.render();
      }

      const page = document.createElement("div");
      page.className = "page";
      page.appendChild(route.render(params, query));
      this.root.replaceChildren(page);
      return;
    }

    // No match → fallback
    const page = document.createElement("div");
    page.className = "page";
    const home = document.createElement("hat-layout-home");
    home.appendChild(document.createElement("hat-welcome"));
    page.appendChild(home);
    this.root.replaceChildren(page);
  }
}

customElements.define("hat-router", HatRouter);